<template>
    <div>
      <div class="loader" v-if="this.isLoading"></div>   
      <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
        <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
  
            <!--begin::navbar-->
            <navbar-component></navbar-component>
            <!--end::navbar-->
  
            <div class="page-wrapper">
  
                    <!--begin::content-->
                    <div class="page-content">
                        <div class="row">
                            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
                                <div class="card">
                                    <div class="card-header">
                                        <div class="row mb-3">
                                            <h4 class="float-start">{{$t("titleCmlDetailLogsSyncTrx") }}</h4>
                                        </div>
                                        <div class="card-body mt-0">
                                            <div class="row mb-3">
                                                <div class="col-md-3">
                                                    <label class="form-label">
                                                        {{$t('idBillingHeader')}}
                                                    </label>
                                                    <input type="text" class="form-control" id="idBillingHeader"
                                                    :placeholder="$t('idBillingHeader')" v-model="formsHeader.idBillingHeader"
                                                    disabled />
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="form-label">
                                                        {{$t('customerId')}}
                                                    </label>
                                                    <input type="text" class="form-control" id="customerId"
                                                    :placeholder="$t('customerId')" v-model="formsHeader.customerId"
                                                    disabled />
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="form-label">
                                                        {{$t('warehouseId_txt')}}
                                                    </label>
                                                    <input type="text" class="form-control" id="warehouseId"
                                                    :placeholder="$t('warehouseId_txt')" v-model="formsHeader.warehouseId"
                                                    disabled />
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="form-label">
                                                        {{$t('transactionDate_txt')}}
                                                    </label>
                                                    <input type="text" class="form-control" id="transactionDate"
                                                    :placeholder="$t('transactionDate_txt')" v-model="formsHeader.transactionDate"
                                                    disabled />
                                                </div>
                                            </div>
                                            <div class="row mb-3">
                                                <div class="col-md-3">
                                                    <label class="form-label">
                                                        {{$t('statusTxt')}}
                                                    </label>
                                                    <input type="text" class="form-control" id="status"
                                                    :placeholder="$t('statusTxt')" v-model="formsHeader.status"
                                                    disabled />
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="form-label">
                                                        {{ $t('amount_txt') }}
                                                    </label>
                                                    <input type="text" class="form-control" id="amount"
                                                    :placeholder="$t('amount_txt')" v-model="formsHeader.amount"
                                                    disabled />
                                                </div>
                                            </div>   
                                                
                                        </div>
                                        <button v-if="permision_role.method_read" class="btn btn-success float-end btn-xs"
                                            style="margin-right: 5px" @click.prevent="downloadData()">
                                            <span class="mdi mdi-download h4"></span>
                                            {{ $t("downloadData") }} .xlsx
                                        </button>
                                        <button class="btn btn-primary text-light fw-bolder btn-icon-text"
                                            @click="backForm" type="button">
                                            <i class="link-icon mdi mdi-arrow-left"></i>
                                            {{ $t("backMess") }}
                                        </button>
                                    </div>
                                    <div class="card-body" v-if="this.formsHeader.status === 'COMPLETED' || this.formsHeader.status === 'PROCESSING' || this.formsHeader.status === 'RECALCULATE' || this.formsHeader.status === 'SYNC FAILED'">
                                        <vue-good-table 
                                        title="list-billing-cml-billing-detail-logs-sync-trx"
                                        ref="list-billing-cml-billing-detail-logs-sync-trx"
                                        :select-options="{enabled: true, selectOnCheckboxOnly: true,selectionText: $t('data_selected'),clearSelectionText: $t('clear'),}" 
                                        mode="remote" styleClass="vgt-table striped"
                                        @on-selected-rows-change="selectionChanged" 
                                        @on-page-change="onPageChange"
                                        @on-sort-change="onSortChange" 
                                        @on-column-filter="onColumnFilter"
                                        @on-per-page-change="onPerPageChange" 
                                        :totalRows="totalRecords" 
                                        :line-numbers="true"
                                        :isLoading.sync="isLoading" 
                                        :pagination-options="{
                                            enabled: true,
                                            perPageDropdown: [10, 50, 100, 1000, 10000],
                                            dropdownAllowAll: false,
                                        }" 
                                        :rows="rows" 
                                        :columns="columns">

                                            <div slot="table-actions">
                                                {{ $t("no_select_data") }}
                                            </div>
                                            <div slot="selected-row-actions">
                                                <button class="btn btn-danger btn-xs" style="margin-right:20px;" @click="selectionChangeStatus"> <i
                                                    class="mdi mdi-send-outline"></i> {{ $t("changeStatus") }}</button>
                                                <button class="btn btn-success btn-xs" @click="removeSelections"><i class="mdi mdi-close"></i> {{
                                                    $t("unselect_data_txt")
                                                }} </button>
                                            </div>

                                            <template slot="column-filter" slot-scope="{ column }">
                                                    <span v-if="column.filterOptions.customFilter">
                                                        <span v-if="column.field =='addDate'">
                                                            <date-range-picker class="w-100" @update="addDatesChange()" control-container-class="form-control" :locale-data="{format:'yyyy-mm-dd'}" v-model="addDates" :opens="opens" :singleDatePicker="false" :timePicker24Hour="false" :timePicker="false" :showWeekNumbers="false">
                                                                <div slot="header" slot-scope="header" class="slot">
                                                                    <a @click="clearaddDatesChange()"></a> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span>
                                                                </div>
                                                            </date-range-picker>
                                                        </span>
                                                        <span v-if="column.field =='editDate'">
                                                            <date-range-picker class="w-100" @update="editDatesChange()" control-container-class="form-control" :locale-data="{format:'yyyy-mm-dd'}" v-model="editDates" :opens="opens" :singleDatePicker="false" :timePicker24Hour="false" :timePicker="false" :showWeekNumbers="false">
                                                                <div slot="header" slot-scope="header" class="slot">
                                                                    <a @click="cleareditDatesChange()"></a> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span>
                                                                </div>
                                                            </date-range-picker>
                                                        </span>
                                                        <span v-if="column.field =='trxDate'">
                                                            <date-range-picker class="w-100" @update="trxDateChange()" control-container-class="form-control" :locale-data="{format:'yyyy-mm-dd'}" v-model="trxDate" :opens="opens" :singleDatePicker="false" :timePicker24Hour="false" :timePicker="false" :showWeekNumbers="false">
                                                                <div slot="header" slot-scope="header" class="slot">
                                                                    <a @click="cleartrxDateChange()"></a> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span>
                                                                </div>
                                                            </date-range-picker>
                                                        </span>
                                                    </span>
                                            </template>

                                            <template slot="table-row" slot-scope="props">
                                                <span v-if="props.column.field == 'actions'">
                                                    <a href="#" v-if="permision_role.method_read"
                                                        title="Sub Detail" @click.prevent="detailData(props.index, props.row)">
                                                        <span class="mdi mdi-eye m-1 h4"></span>
                                                    </a>
                                                    <a href="#" v-if="permision_role.method_update && props.row.status !== 'QUEUED'" title="Sync Queued" @click.prevent=" changeStatusData(props.index, props.row , 'QUEUED')">
                                                        <span class="mdi mdi-cloud-sync-outline h4"></span>
                                                    </a>
                                                    <a href="#" v-else-if="permision_role.method_update && props.row.status !== 'COMPLETED'" title="Sync Completed" @click.prevent=" changeStatusData(props.index, props.row , 'COMPLETED')">
                                                        <span class="mdi mdi-cloud-check-outline h4"></span>
                                                    </a>
                                                </span>
                                                <span v-else-if="props.column.field == 'status'">
                                                    <span v-if="props.row.status == 'QUEUED'" class="badge bg-secondary"><h5>{{props.row.status}}</h5></span>
                                                    <span v-else-if="props.row.status == 'PROCESSING'" class="badge bg-warning"><h5>{{props.row.status}}</h5></span>
                                                    <span v-else-if="props.row.status == 'COMPLETED'" class="badge bg-success"><h5>{{props.row.status}}</h5></span>
                                                    <span v-else class="badge bg-danger"><h5>{{props.row.status}}</h5></span>
                                                </span>
                                                <span v-else-if="props.column.field == 'addDate'">
                                                    {{ format_date(props.row.addDate) }}
                                                </span>
                                                <span v-else-if="props.column.field == 'editDate'">
                                                    {{ format_date(props.row.editDate) }}
                                                </span>
                                                <span v-else-if="props.column.field == 'countRowEksternal'">
                                                    <span v-if="props.row.countRowEksternal === null"> - </span>
                                                    <span v-else> {{props.row.countRowEksternal}} </span>
                                                </span>
                                                <span v-else-if="props.column.field == 'countRowInternal'">
                                                    <span v-if="props.row.countRowInternal === null"> - </span>
                                                    <span v-else> {{props.row.countRowInternal}} </span>
                                                </span>
                                                
                                                <span v-else>
                                                    {{ props.formattedRow[props.column.field] }}
                                                </span>
                                            </template>

                                        </vue-good-table>
                                    </div>
                                    <div class="card-body" v-else>
                                        <vue-good-table 
                                        title="list-billing-cml-billing-detail-logs-sync-trx"
                                        ref="list-billing-cml-billing-detail-logs-sync-trx"
                                        :select-options="{enabled: false, selectOnCheckboxOnly: true,selectionText: $t('data_selected'),clearSelectionText: $t('clear'),}" 
                                        mode="remote" styleClass="vgt-table striped"
                                        @on-selected-rows-change="selectionChanged" 
                                        @on-page-change="onPageChange"
                                        @on-sort-change="onSortChange" 
                                        @on-column-filter="onColumnFilter"
                                        @on-per-page-change="onPerPageChange" 
                                        :totalRows="totalRecords" 
                                        :line-numbers="true"
                                        :isLoading.sync="isLoading" 
                                        :pagination-options="{
                                            enabled: true,
                                            perPageDropdown: [10, 50, 100, 1000, 10000],
                                            dropdownAllowAll: false,
                                        }" 
                                        :rows="rows" 
                                        :columns="columns">

                                            <div slot="table-actions">
                                                {{ $t("no_select_data") }}
                                            </div>
                                            <div slot="selected-row-actions">
                                                <button class="btn btn-danger btn-xs" style="margin-right:20px;" @click="selectionChangeStatus"> <i
                                                    class="mdi mdi-send-outline"></i> {{ $t("changeStatus") }}</button>
                                                <button class="btn btn-success btn-xs" @click="removeSelections"><i class="mdi mdi-close"></i> {{
                                                    $t("unselect_data_txt")
                                                }} </button>
                                            </div>

                                            <template slot="column-filter" slot-scope="{ column }">
                                                    <span v-if="column.filterOptions.customFilter">
                                                        <span v-if="column.field =='addDate'">
                                                            <date-range-picker class="w-100" @update="addDatesChange()" control-container-class="form-control" :locale-data="{format:'yyyy-mm-dd'}" v-model="addDates" :opens="opens" :singleDatePicker="false" :timePicker24Hour="false" :timePicker="false" :showWeekNumbers="false">
                                                                <div slot="header" slot-scope="header" class="slot">
                                                                    <a @click="clearaddDatesChange()"></a> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span>
                                                                </div>
                                                            </date-range-picker>
                                                        </span>
                                                        <span v-if="column.field =='editDate'">
                                                            <date-range-picker class="w-100" @update="editDatesChange()" control-container-class="form-control" :locale-data="{format:'yyyy-mm-dd'}" v-model="editDates" :opens="opens" :singleDatePicker="false" :timePicker24Hour="false" :timePicker="false" :showWeekNumbers="false">
                                                                <div slot="header" slot-scope="header" class="slot">
                                                                    <a @click="cleareditDatesChange()"></a> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span>
                                                                </div>
                                                            </date-range-picker>
                                                        </span>
                                                        <span v-if="column.field =='trxDate'">
                                                            <date-range-picker class="w-100" @update="trxDateChange()" control-container-class="form-control" :locale-data="{format:'yyyy-mm-dd'}" v-model="trxDate" :opens="opens" :singleDatePicker="false" :timePicker24Hour="false" :timePicker="false" :showWeekNumbers="false">
                                                                <div slot="header" slot-scope="header" class="slot">
                                                                    <a @click="cleartrxDateChange()"></a> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span>
                                                                </div>
                                                            </date-range-picker>
                                                        </span>
                                                    </span>
                                            </template>

                                            <template slot="table-row" slot-scope="props">
                                                <span v-if="props.column.field == 'actions'">
                                                    <a href="#" v-if="permision_role.method_read"
                                                        title="Sub Detail" @click.prevent="detailData(props.index, props.row)">
                                                        <span class="mdi mdi-eye m-1 h4"></span>
                                                    </a>
                                                    <!--<a href="#" v-if="permision_role.method_update && props.row.status !== 'QUEUED'" title="QUEUED" @click.prevent=" changeStatusData(props.index, props.row , 'QUEUED')">
                                                        <button class="btn btn-secondary btn-sm">QUEUED</button>
                                                    </a>
                                                    <a href="#" v-else-if="permision_role.method_update && props.row.status !== 'COMPLETED'" title="COMPLETED" @click.prevent=" changeStatusData(props.index, props.row , 'COMPLETED')">
                                                        <button class="btn btn-success btn-sm">COMPLETED</button>
                                                    </a>-->
                                                </span>
                                                <span v-else-if="props.column.field == 'status'">
                                                    <span v-if="props.row.status == 'QUEUED'" class="badge bg-secondary"><h5>{{props.row.status}}</h5></span>
                                                    <span v-else-if="props.row.status == 'PROCESSING'" class="badge bg-warning"><h5>{{props.row.status}}</h5></span>
                                                    <span v-else-if="props.row.status == 'COMPLETED'" class="badge bg-success"><h5>{{props.row.status}}</h5></span>
                                                    <span v-else class="badge bg-danger"><h5>{{props.row.status}}</h5></span>
                                                </span>
                                                <span v-else-if="props.column.field == 'addDate'">
                                                    {{ format_date(props.row.addDate) }}
                                                </span>
                                                <span v-else-if="props.column.field == 'editDate'">
                                                    {{ format_date(props.row.editDate) }}
                                                </span>
                                                <span v-else-if="props.column.field == 'countRowEksternal'">
                                                    <span v-if="props.row.countRowEksternal === null"> - </span>
                                                    <span v-else> {{props.row.countRowEksternal}} </span>
                                                </span>
                                                <span v-else-if="props.column.field == 'countRowInternal'">
                                                    <span v-if="props.row.countRowInternal === null"> - </span>
                                                    <span v-else> {{props.row.countRowInternal}} </span>
                                                </span>
                                                
                                                <span v-else>
                                                    {{ props.formattedRow[props.column.field] }}
                                                </span>
                                            </template>

                                        </vue-good-table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--end::content-->

                    <!--begin::modal-->
                    <modal name="detailLogsSyncTrx" :draggable="false" :scrollable="true" :height="'auto'">
                        <div class="modal fade show" tabindex="-1" style="display: block;" aria-modal="true" role="dialog">
                            <div class="modal-dialog modal-dialog-centered modal-xl">
                                <div class="modal-content">
                                
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="exampleModalLabel">{{this.$t("titleCmlDetailLogsSyncTrx")}}</h5>
                                        <button type="button" class="btn-close" aria-label="btn-close" @click.prevent="removeModals()"></button>
                                    </div>
                                
                                    <div class="modal-body">
                                        <div class="row justify-content-md-center px-3">
                                            <div class="row mb-3">
                                                <div class="col-md-4">
                                                    <label for="idLog" class="form-label">{{this.$t("idLog")}} :</label>
                                                    <input type="text" class="form-control" id="idLog" :placeholder="$t('idLog')" v-model="forms.idLog" disabled/>
                                                    <div v-if="errors.idLog">
                                                    <div
                                                        v-for="error in errors.idLog"
                                                        :key="error"
                                                        class="alert alert-primary"
                                                        role="alert"
                                                    >
                                                        <i data-feather="alert-circle"></i>
                                                        {{ error }}
                                                    </div>
                                                    </div>
                                                
                                                </div>
                                                <div class="col-md-4">
                                                    <label for="addDate" class="form-label">{{this.$t("adddate")}} :</label>
                                                    <input type="text" class="form-control" id="addDate" :placeholder="$t('adddate')" v-model="addDate" disabled/>
                                                    <div v-if="errors.addDate">
                                                    <div
                                                        v-for="error in errors.addDate"
                                                        :key="error"
                                                        class="alert alert-primary"
                                                        role="alert"
                                                    >
                                                        <i data-feather="alert-circle"></i>
                                                        {{ error }}
                                                    </div>
                                                    </div>
                                                
                                                </div>
                                                <div class="col-md-4">
                                                    <label for="editDate" class="form-label">{{this.$t("editdate")}} :</label>
                                                    <input type="text" class="form-control" id="editDate" :placeholder="$t('editdate')" v-model="editDate" disabled/>
                                                    <div v-if="errors.editDate">
                                                    <div
                                                        v-for="error in errors.editDate"
                                                        :key="error"
                                                        class="alert alert-primary"
                                                        role="alert"
                                                    >
                                                        <i data-feather="alert-circle"></i>
                                                        {{ error }}
                                                    </div>
                                                    </div>
                                                
                                                </div>
                                            </div>
                                            <div class="row mb-3">
                                                <div class="col-md-4">
                                                    <label for="status" class="form-label">{{this.$t("status")}} :</label>
                                                    <input type="text" class="form-control" id="status" :placeholder="$t('status')" v-model="forms.status" disabled/>
                                                    <div v-if="errors.status">
                                                    <div
                                                        v-for="error in errors.status"
                                                        :key="error"
                                                        class="alert alert-primary"
                                                        role="alert"
                                                    >
                                                        <i data-feather="alert-circle"></i>
                                                        {{ error }}
                                                    </div>
                                                    </div>
                                                
                                                </div>
                                                <div class="col-md-4">
                                                    <label for="trxDate" class="form-label">{{this.$t("trxDate")}} :</label>
                                                    <input type="text" class="form-control" id="trxDate" :placeholder="$t('trxDate')" v-model="forms.trxDate" disabled/>
                                                    <div v-if="errors.trxDate">
                                                    <div
                                                        v-for="error in errors.trxDate"
                                                        :key="error"
                                                        class="alert alert-primary"
                                                        role="alert"
                                                    >
                                                        <i data-feather="alert-circle"></i>
                                                        {{ error }}
                                                    </div>
                                                    </div>
                                                
                                                </div>
                                                <div class="col-md-4">
                                                    <label for="subType" class="form-label">{{this.$t("trxTypeName")}} :</label>
                                                    <input type="text" class="form-control" id="subType" :placeholder="$t('trxTypeName')" v-model="forms.subType" disabled/>
                                                    <div v-if="errors.subType">
                                                    <div
                                                        v-for="error in errors.subType"
                                                        :key="error"
                                                        class="alert alert-primary"
                                                        role="alert"
                                                    >
                                                        <i data-feather="alert-circle"></i>
                                                        {{ error }}
                                                    </div>
                                                    </div>
                                                
                                                </div>
                                                
                                            </div>
                                            <div class="row mb-3">
                                                <div class="col-md-4">
                                                    <label for="type" class="form-label">{{this.$t("transactionType")}} :</label>
                                                    <input type="text" class="form-control" id="type" :placeholder="$t('transactionType')" v-model="forms.type" disabled/>
                                                    <div v-if="errors.type">
                                                    <div
                                                        v-for="error in errors.type"
                                                        :key="error"
                                                        class="alert alert-primary"
                                                        role="alert"
                                                    >
                                                        <i data-feather="alert-circle"></i>
                                                        {{ error }}
                                                    </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <label for="countRowEksternal" class="form-label">{{this.$t("countRowEksternal")}} :</label>
                                                    <input type="text" class="form-control" id="countRowEksternal" :placeholder="$t('countRowEksternal')" v-model="forms.countRowEksternal" disabled/>
                                                    <div v-if="errors.countRowEksternal">
                                                    <div
                                                        v-for="error in errors.countRowEksternal"
                                                        :key="error"
                                                        class="alert alert-primary"
                                                        role="alert"
                                                    >
                                                        <i data-feather="alert-circle"></i>
                                                        {{ error }}
                                                    </div>
                                                    </div>
                                                
                                                </div>
                                                <div class="col-md-4">
                                                    <label for="countRowInternal" class="form-label">{{this.$t("countRowInternal")}} :</label>
                                                    <input type="text" class="form-control" id="countRowInternal" :placeholder="$t('countRowInternal')" v-model="forms.countRowInternal" disabled/>
                                                    <div v-if="errors.countRowInternal">
                                                    <div
                                                        v-for="error in errors.countRowInternal"
                                                        :key="error"
                                                        class="alert alert-primary"
                                                        role="alert"
                                                    >
                                                        <i data-feather="alert-circle"></i>
                                                        {{ error }}
                                                    </div>
                                                    </div>
                                                
                                                </div>
                                            </div>
                                            <div class="row mb-3">
                                                <div class="col-md">
                                                    <label for="datas" class="form-label">{{this.$t("datas")}} :</label>
                                                    <input type="text" class="form-control" id="datas" :placeholder="$t('datas')" v-model="forms.datas" disabled/>
                                                    <div v-if="errors.datas">
                                                    <div
                                                        v-for="error in errors.datas"
                                                        :key="error"
                                                        class="alert alert-primary"
                                                        role="alert"
                                                    >
                                                        <i data-feather="alert-circle"></i>
                                                        {{ error }}
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mb-3">
                                                <div class="col-md-12">
                                                    <label for="response" class="form-label">{{this.$t("datas_response")}} :</label>
                                                    <textarea
                                                    class="form-control"
                                                    id="response"
                                                    :placeholder="$t('datas_response')"
                                                    v-model="forms.response"
                                                    rows="10"
                                                    max-rows="20"
                                                    disabled
                                                    ></textarea>
                                                    <div v-if="errors.response">
                                                    <div
                                                        v-for="error in errors.response"
                                                        :key="error"
                                                        class="alert alert-primary"
                                                        role="alert"
                                                    >
                                                        <i data-feather="alert-circle"></i>
                                                        {{ error }}
                                                    </div>
                                                    </div>
                                                
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                
                                    <div class="modal-footer justify-content-between">
                                        <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">{{this.$t("close_txt")}}</button>
                                    </div>
                                
                                </div>
                            </div>
                        </div>
                    </modal>
                    <!--end::modal-->


  
                <!--begin::footer-->
                <footer-component></footer-component>
                <!--end::footer-->


            </div>

      </div>
    </div>
</template>
  
  
<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import DateRangePicker from 'vue2-daterange-picker';

export default {
    name: "CmlBillingLogsSyncTrx",
    props: {},
    components: {
        "navbar-component": navbarComponent,
        "footer-component": footerComponent,
        DateRangePicker
    },
    computed: {
        addDate() {
            return this.$moment(this.forms.addDate).format('yyyy-MM-DD HH:mm:ss');
        },
        editDate() {
            return this.$moment(this.forms.editDate).format('yyyy-MM-DD HH:mm:ss');
        }
    },
    data() {
        return {
            opens:"center",
            locale:{
                format:"yyyy-mm-dd",
            },
            trxDate: {
                startDate: null,
                endDate: null
            },
            addDates: {
                    startDate: null,
                    endDate: null
            },
            editDates: {
                    startDate: null,
                    endDate: null
            },
            firstDates: {
                startDate: null,
                endDate: null
            },
            highlighted:{
                dates: [ // Highlight an array of dates
                    new Date(),
                ],
            },
            serverParams: {
                columnFilters: {},
                sort: {
                    field: "",
                    type: "",
                },
                page: 1,
                per_page: 10,
            },
            maxToasts: 100,
            position: "up right",
            closeBtn: true,
            isLoading: false,
            errors: [],
            permision_role:[],
            langs: ["id", "en"],
            detailUser: [],
            idBillingHeader: [],
            detailDivisi: [],
            totalRecords: 0,
            trxDateFrom: "",
            trxDateTo: "",
            addDateFrom: "",
            addDateTo: "",
            editDateFrom: "",
            editDateTo: "",
            columns: [
            {
                label: this.$t("action_txt"),
                field: "actions",
                width: "80px",
                thClass: 'text-center',
                tdClass: 'text-center',
                sortable: false,
                filterOptions: {
                customFilter: false,
                enabled: false, 
                },
            },
            {
            label: this.$t("idLog"),
            field: "idLog",
            thClass: 'text-center',
            tdClass: 'text-center',
            width: '80px',
            filterOptions: {
                customFilter: false,
                enabled: true, // enable filter for this column
                placeholder: this.$t("idLog"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                },
            },
            {
            label: this.$t("type"),
            field: "type",
            thClass: 'text-center',
            tdClass: 'text-center',
            width: "80px",
            filterOptions: {
                customFilter: false,
                enabled: true, // enable filter for this column
                placeholder: this.$t("type"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: ["yesterday", "recalculate"], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                },
            },
            {
            label: this.$t("typeName"),
            field: "subType",
            thClass: 'text-center',
            tdClass: 'text-center',
            width: "80px",
            filterOptions: {
                customFilter: false,
                enabled: true, // enable filter for this column
                placeholder: this.$t("typeName"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                },
            },
            {
            label: this.$t("adddate"),
            field: "addDate",
            thClass: 'text-center',
            tdClass: 'text-center',
            width: '100px',
            filterOptions: {
                customFilter: true,
                enabled: true, // enable filter for this column
                placeholder: this.$t("adddate"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                },
            },
            {
            label: this.$t("editdate"),
            field: "editDate",
            thClass: 'text-center',
            tdClass: 'text-center',
            width: '110px',
            filterOptions: {
                customFilter: true,
                enabled: true, // enable filter for this column
                placeholder: this.$t("editdate"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                },
            },
            
            {
            label: this.$t("trxDate"),
            field: "trxDate",
            thClass: 'text-center',
            tdClass: 'text-center',
            width: '180px',
            filterOptions: {
                customFilter: false,
                enabled: false, // enable filter for this column
                placeholder: this.$t("trxDate"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                },
            },
            {
            label: this.$t("countRowEksternal"),
            field: "countRowEksternal",
            thClass: 'text-center',
            tdClass: 'text-center',
            width: "90px",
            filterOptions: {
                customFilter: false,
                enabled: false, // enable filter for this column
                placeholder: this.$t("countRowEksternal"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                },
            },
            {
            label: this.$t("countRowInternal"),
            field: "countRowInternal",
            thClass: 'text-center',
            tdClass: 'text-center',
            width: "90px",
            filterOptions: {
                customFilter: false,
                enabled: false, // enable filter for this column
                placeholder: this.$t("countRowInternal"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                },
            },
            {
            label: this.$t("status"),
            field: "status",
            thClass: 'text-center',
            tdClass: 'text-center',
            width: '80px',
            filterOptions: {
                customFilter: false,
                enabled: true, // enable filter for this column
                placeholder: this.$t("all"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: ['QUEUED','PROCESSING','COMPLETED','FAILED'], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                },
            },
            ],
            rows: [],
            rowsSelection: [],
            idCodeLkupsSelections: [],
            forms: {idLog: "",  status:"",  trxDate:"", subType:"", category:"", type:"",  countRowEksternal:"" , countRowInternal:"", datas:"", response:"",  addDate:"", editDate:""},
            formsHeader: {idBillingHeader: "",  tariffId:"",  customerId:"", warehouseId:"", transactionToDate:"", transactionFromDate:"",  status:"" , amount:"", idRateHeader:"",  transactionDate:"", addwho:"",  editwho:"", adddate:"",  editdate:""},

        };
    },
    watch: {},
    methods: {

    addDatesChange(){
        if(this.addDates.startDate && this.addDates.endDate){
            this.addDateFrom    =this.$moment(String(this.addDates.startDate)).format('YYYY-MM-DD');
            this.addDateTo      =this.$moment(String(this.addDates.endDate)).format('YYYY-MM-DD');
            this.loadItems()
        }
    },

    clearaddDatesChange(){
            this.addDates   ={
                startDate: null,
                endDate: null
            };
            this.addDateFrom    = ""
            this.addDateTo      = ""
            this.loadItems()
    },

    editDatesChange(){
        if(this.editDates.startDate && this.editDates.endDate){
            this.editDateFrom    =this.$moment(String(this.editDates.startDate)).format('YYYY-MM-DD');
            this.editDateTo      =this.$moment(String(this.editDates.endDate)).format('YYYY-MM-DD');
            this.loadItems()
        }
    },

    cleareditDatesChange(){
            this.editDates   ={
                startDate: null,
                endDate: null
            };
            this.editDateFrom    = ""
            this.editDateTo      = ""
            this.loadItems()
    },

    trxDateChange() {
        if (this.trxDate.startDate && this.trxDate.endDate) {
            this.trxDateFrom = this.$moment(String(this.trxDate.startDate)).format('YYYY-MM-DD');
            this.trxDateTo = this.$moment(String(this.trxDate.endDate)).format('YYYY-MM-DD');
            this.loadItems()
        }

    },

    cleartrxDateChange() {
        this.trxDate = {
            startDate: null,
            endDate: null
        };
        this.trxDateFrom = ""
        this.trxDateTo = ""
        this.loadItems()
    },

    removeModals(){
      
        this.$modal.hide('detailLogsSyncTrx')
        this.forms.idLog                = ""
        this.forms.status               = ""
        this.forms.trxDate              = ""
        this.forms.subType              = ""
        this.forms.category             = ""
        this.forms.type                 = ""
        this.forms.countRowEksternal    = ""
        this.forms.countRowInternal     = ""
        this.forms.datas                = ""
        this.forms.response             = ""
        this.forms.addDate              = ""
        this.forms.editDate             = ""

    },

    detailData(index, row) {
        this.forms.idLog                = row.idLog
        this.forms.status               = row.status
        this.forms.trxDate              = row.trxDate
        this.forms.subType              = row.subType
        this.forms.category             = row.category
        this.forms.type                 = row.type
        this.forms.countRowEksternal    = row.countRowEksternal === null ? '-' : row.countRowEksternal
        this.forms.countRowInternal     = row.countRowInternal === null ? '-' : row.countRowInternal
        this.forms.response             = row.response
        this.forms.datas                = row.datas
        this.forms.addDate              = row.addDate
        this.forms.editDate             = row.editDate
        this.$modal.show('detailLogsSyncTrx') 
    },

    format_date(value){
     if (value) {
       return this.$moment(String(value)).format('yyyy-MM-DD HH:mm:ss')
      }
    },
    
    submitBillingListData(){
        console.log("ok")
    },

    resetForm(){
        this.fileOvertime              = ""
        this.fileExtraHandling         = ""
        this.fileDataSAP               = ""
        this.fileDataAdditionalWMS     = ""
        this.clearrecalculateDates()
    },

    cek_message(status, msg) {
          if (status == "200") {
              this.success(msg);
          }
    },

    toCurrency (value) {
        if (typeof value !== "number") {
            return value;
        }
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'IDR'
        });
        return formatter.format(value);
    },

    fade(sType) {
          this.isLoading = sType;
    },

    loading() {
          this.fade(true);
          setTimeout(() => {
              this.fade(false);
          }, 1000); // hide the message after 3 seconds
    },

    resultError(data){
          var count = Object.keys(data).length;
          for (var x = 0; x < count; x++) {
              var nameOb = Object.keys(data)[x];
              var objectData = data[nameOb];
              for (var y = 0; y < objectData.length; y++) {
              this.error(objectData[y]);
              }
          }
    },

    success(kata) {
          const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
              // onShown: function() {
              //     console.log('asdasdasd');
              //     //window.location.href = '/';
              // }
          });

          Toast.fire({
              icon: "success",
              title: kata,
          });
    },

    error(kata){
          const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
          });
          Toast.fire({
              icon: "error",
              title: kata,
          });
    },

    logout(){

          const baseURI = this.$settings.endPoint + "user/logout";
          this.$http.get(baseURI, { timeout: 60000 }).then((response) => {
              
          console.log(response);

          });

          this.$logoutUser();
          window.location.href = '/';
    },

    backForm() {
        var params = this.$onRandom(this.formsHeader.idBillingHeader);
        window.location.href = "/billing-cml/billing/header/detail/" + params;
    },


    loadItems() {

            let trxDateFrom = this.trxDateFrom
            let trxDateTo   = this.trxDateTo
            let addDateFrom = this.addDateFrom
            let addDateTo   = this.addDateTo
            let editDateFrom = this.editDateFrom
            let editDateTo   = this.editDateTo

            var params = this.$onBehind(this.$route.params.id);
            const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/billing/index-logs-sync-trx/" + params[0];
            this.isLoading = true;

            return this.$http
                .get(
                    baseURI +
                    `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&idLog=${this.serverParams.columnFilters.idLog}&trxDateFrom=${trxDateFrom}&trxDateTo=${trxDateTo}&subType=${this.serverParams.columnFilters.subType}&status=${this.serverParams.columnFilters.status}&type=${this.serverParams.columnFilters.type}&subType=${this.serverParams.columnFilters.subType}&addDateFrom=${addDateFrom}&addDateTo=${addDateTo}&editDateFrom=${editDateFrom}&editDateTo=${editDateTo}`,
                    { timeout: 60000 })
                .then((response) => {
                    this.isLoading = false;
                    this.rows = response.data.datas.data;
                    this.totalRecords = response.data.datas.total;
                }).catch((error) => {
                    this.loading();

                    if (error.code == "ECONNABORTED") {
                        this.error(this.$t("check_internet_connection_txt"));

                    } else {

                        if (error.response) {
                            if (error.response.status === 422) {
                                this.errors = error.response.data.errors;
                                this.resultError(error.response.data.errors);
                            } else if (error.response.status === 401) {
                                this.logout();
                            } else if (error.response.status === 403) {
                                this.$router.push("/authorized-error");
                            } else if (error.response.status === 500) {
                                this.$router.push('/server-error');
                            } else {
                                this.$router.push('/page-not-found');
                            }
                        }

                    }

                });
    },

    downloadData() {
                var params = this.$onBehind(this.$route.params.id);
                const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/billing/index-logs-sync-trx/" + params[0];
                this.isLoading = true;
                var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
                var file_name = "download_" + CurrentDate + ".xlsx";
         
                let trxDateFrom = this.trxDateFrom
                let trxDateTo   = this.trxDateTo
                let addDateFrom = this.addDateFrom
                let addDateTo   = this.addDateTo
                let editDateFrom = this.editDateFrom
                let editDateTo   = this.editDateTo

                return this.$http
                .get(
                    baseURI +
                    `?editDateFrom=${editDateFrom}&editDateTo=${editDateTo}&addDateFrom=${addDateFrom}&addDateTo=${addDateTo}&idLog=${this.serverParams.columnFilters.idLog}&trxDateFrom=${trxDateFrom}&trxDateTo=${trxDateTo}&subType=${this.serverParams.columnFilters.subType}&status=${this.serverParams.columnFilters.status}&type=${this.serverParams.columnFilters.type}&subType=${this.serverParams.columnFilters.subType}&download=download`,
                    {
                    responseType: "blob",
                    }
                )
                .then((response) => {
                    this.isLoading = false;
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement("a");
        
                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", file_name);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.fade(false);
                });
    },

    updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
            this.loadItems();
    },

    onColumnFilter(params) {
            this.updateParams(params);
    },

    onPageChange(params) {
            this.updateParams({ page: params.currentPage });
    },

    onSortChange(params) {
            this.updateParams({
                sort: {
                    type: params[0].type,
                    field: params[0].field,
                },
            });
    },

    onPerPageChange(params) {
            this.updateParams({ per_page: params.currentPerPage });
    },

    selectionChanged(ev) {

        this.rowsSelection = [];
        this.idCodeLkupsSelections  = [];
        this.rowsSelection = ev.selectedRows;

        this.rowsSelection.forEach((item) => {
        this.idCodeLkupsSelections.push(item.idLog);

        });

    },

    

    fetchIt() {
          const userDatas       = this.$getUserInfo();
          this.userData         = userDatas.sub;
          // this.permision_role = userDatas.sub.permision_role;
          let rolePermision     = [];
          userDatas.sub.permision_role.forEach(function(permision){
              if(permision.permission.controller == 'BillingCmlController'){

              rolePermision = permision;
              // console.log(permision);
              }
          });

          if(!rolePermision.method_read){
              this.$router.push("/authorized-error");
          }

          this.permision_role = rolePermision;
          this.loadData();

    },

    loadData() {
          this.isLoading = true;
          var params = this.$onBehind(this.$route.params.id);

          const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/billing/detail/" + params[0];
          return this.$http.get(baseURI,{ timeout: 60000 }).then((response) => {
              this.isLoading = false;
              this.formsHeader                      = response.data.datas;
              this.formsHeader.amount               = this.toCurrency(response.data.datas.amount);
              this.bm_rate_header                   = response.data.datas.bm_rate_header;
              this.formsHeader.transactionDate      = response.data.datas.transactionFromDate+"~"+response.data.datas.transactionToDate
          }).catch(error => {
              this.isLoading = false;
            
        
          if(error.code == "ECONNABORTED"){
              this.error(this.$t("check_internet_connection_txt"));
              
          }else{

              if (error.response) {
                  if(error.response.status === 422) {
                      this.errors = error.response.data.errors;
                      this.resultError(error.response.data.errors);
                  }else if (error.response.status === 401) {
                      this.logout();
                  } else if (error.response.status === 403) {
                      this.$router.push("/authorized-error");
                  }else if (error.response.status === 500) {
                      this.$router.push('/server-error');
                  }else{
                      this.$router.push('/page-not-found');
                  }
              }

          }

          });
    },

    selectionChangeStatus(){
        this.$swal({
            title: this.$t("areYouSure"),
            text: this.$t("yourDataSend"),
            showCancelButton: true,
            confirmButtonColor: "#198754",
            cancelButtonColor: "#adb5bd",
            confirmButtonText: "COMPLETED",
            cancelButtonText: 'QUEUED',
            }).then((result) => {
                if (result.value) 
                {
                        this.isLoading = true;

                        let formData = {
                            idBillingHeader: this.formsHeader.idBillingHeader,
                            idLogs: this.idCodeLkupsSelections,
                            status: "COMPLETED",
                        };
                        
                        const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/billing/logs-sync-trx-update-status";
                            this.$http
                            .post(baseURI, formData,{ timeout: 60000 })
                            .then((response) => {
                            this.loading();
                                if (response.data.status === 200) 
                                {
                                    this.success(response.data.datas.messages);
                                    this.idCodeLkupsSelections = [];
                                    this.loadItems();
                                } 
                                else 
                                {
                                    this.errors = response.data.errors;
                                    this.resultError(response.data.errors);
                                }
                            }).catch((error) => {
                                    this.loading();

                                if(error.code == "ECONNABORTED"){
                                    this.error(this.$t("check_internet_connection_txt"));
                                }else{
                                if (error.response){
                                    if(error.response.status === 422) {
                                        this.errors = error.response.data.errors;
                                        this.resultError(error.response.data.errors);
                                    }else if (error.response.status === 401) {
                                        this.logout();
                                    } else if (error.response.status === 403) {
                                        this.$router.push("/authorized-error");
                                    }else if (error.response.status === 500) {
                                        this.$router.push('/server-error');
                                    }else{
                                        this.$router.push('/page-not-found');
                                    }
                                }

                                }

                        });

                }
                else
                {
                            
                        this.isLoading = true;
                        let formData = {
                            idBillingHeader: this.formsHeader.idBillingHeader,
                            idLogs: this.idCodeLkupsSelections,
                            status: "QUEUED",
                        };

                        const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/billing/logs-sync-trx-update-status";
                            this.$http
                            .post(baseURI, formData,{ timeout: 60000 })
                            .then((response) => {
                            this.loading();
                            if (response.data.status === 200) {
                                this.success(response.data.datas.messages);
                                this.idCodeLkupsSelections = [];
                                this.loadItems();

                            } else {
                                this.errors = response.data.errors;
                                this.resultError(response.data.errors);
                            }
                            }).catch((error) => {
                                this.loading();
                              
                                if(error.code == "ECONNABORTED"){
                                this.error(this.$t("check_internet_connection_txt"));
                                }else{

                                    if (error.response) {
                                        if(error.response.status === 422) {
                                            this.errors = error.response.data.errors;
                                            this.resultError(error.response.data.errors);
                                        }else if (error.response.status === 401) {
                                            this.logout();
                                        } else if (error.response.status === 403) {
                                            this.$router.push("/authorized-error");
                                        }else if (error.response.status === 500) {
                                            this.$router.push('/server-error');
                                        }else{
                                            this.$router.push('/page-not-found');
                                        }
                                    }

                                }

                            });


                }
        });

    },

    removeSelections(){
        this.idCodeLkupsSelections = [];
        this.$refs['list-billing-cml-billing-detail-logs-sync-trx'].unselectAllInternal()
    },

    changeStatusData(index, row , statusNya) {
        this.$swal({
            title: this.$t("areYouSure"),
            text: this.$t("yourData"),
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes!",
        }).then((result) => {
            if (result.value) {
                    var formData = {
                        idBillingHeader: this.formsHeader.idBillingHeader,
                        idLogs: [row.idLog],
                        status: statusNya,
                    };
                    const baseURI =
                        this.$settings.endPointBilling + "dashboard/cml-billing/billing/logs-sync-trx-update-status";
                        this.$http
                        .post(baseURI, formData,{ timeout: 60000 })
                        .then((response) => {
                        this.loading();
                        if (response.data.status === 200) {
                            this.success(response.data.datas.messages);
                            this.loadItems();

                        } else {
                            this.errors = response.data.errors;
                            this.resultError(response.data.errors);
                        }
                        }).catch((error) => {
                            this.loading();
                          
                            if(error.code == "ECONNABORTED"){
                                this.error(this.$t("check_internet_connection_txt"));
                            }else{
                                if (error.response) {
                                    if(error.response.status === 422) {
                                        this.errors = error.response.data.errors;
                                        this.resultError(error.response.data.errors);
                                    }else if (error.response.status === 401) {
                                        this.logout();
                                    } else if (error.response.status === 403) {
                                        this.$router.push("/authorized-error");
                                    }else if (error.response.status === 500) {
                                        this.$router.push('/server-error');
                                    }else{
                                        this.$router.push('/page-not-found');
                                    }
                                }

                            }
                        });

            }else{
            this.isLoading = false;
            }
        });

    },


    },
    events: {},
    created: function () {},
    mounted() {
        this.fetchIt();
        this.loading();
    },

};

</script>

<style scoped>

.blur-content{
    filter: blur(5px); 
  }

.daterangepicker {
    flex-wrap: nowrap !important;
}



</style>